import { createContext, ReactNode, useState } from "react";
import Snackbar from "@/components/ui/snackbar/index";

export interface SnackbarContextValue {
  showSnackbar: (content: ReactNode, timeout?: number) => void;
  closeSnackbar: () => void;
}

interface SnackbarProviderProps {
  children?: ReactNode;
}

export const SnackbarContext = createContext<SnackbarContextValue>({
  showSnackbar: () => {},
  closeSnackbar: () => {},
});

const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState<React.ReactNode>(null);
  const [timeoutID, setTimeoutID] = useState<any>("");

  const showSnackbar = (content: React.ReactNode, timeout: number = 4000) => {
    setContent(content);
    setShow(true);
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
    const id = setTimeout(() => {
      setShow(false);
      setContent("");
    }, timeout);
    setTimeoutID(id);
  };

  const closeSnackbar = () => {
    setShow(false);
  };

  const value = {
    showSnackbar,
    closeSnackbar,
  };

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      {show && <Snackbar>{content}</Snackbar>}
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
